import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "blogs-content" }
const _hoisted_2 = { class: "main-title" }
const _hoisted_3 = { class: "bg-text" }
const _hoisted_4 = { class: "port-text" }
const _hoisted_5 = { class: "blogs" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "blog-text" }
const _hoisted_8 = ["dir"]

import { ref, computed } from 'vue'
  import { useI18n } from 'vue-i18n';

  import img1 from '@/assets/img/newswebsite.webp';
import img2 from '@/assets/img/compare-price.jpg';
import img3 from '@/assets/img/blog2.jpg';
import img4 from '@/assets/img/blog3.jpg';
import img5 from '@/assets/img/mobile.jpg';

// Local blog data with translation keys

export default /*#__PURE__*/_defineComponent({
  __name: 'Blogs',
  setup(__props) {

  const { locale } = useI18n();

  const isRTL = computed(() => {
  return locale.value === 'ar'; // 'ar' is the code for Arabic
  });
// Import images
const blogs = [
  {
    img: img1,
    title: 'projects.elWess',
    description: 'projects.elWessDesc',
  },
  {
    img: img2,
    title: 'projects.piCompare',
    description: 'projects.piCompareDesc',
  },
  {
    img: img3,
    title: 'projects.moyMgmt',
    description: 'projects.moyMgmtDesc',
  },
  {
    img: img4,
    title: 'projects.yDownload',
    description: 'projects.yDownloadDesc',
  },
  {
    img: img5,
    title: 'projects.routeGenius',
    description: 'projects.routeGeniusDesc',
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('myWorks')) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('works')), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('myWorks')), 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('workDescription')), 1),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blogs, (blog, index) => {
        return _createElementVNode("div", {
          class: "blog",
          key: index
        }, [
          _createElementVNode("img", {
            src: blog.img,
            alt: _ctx.$t(blog.title)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t(blog.title)), 1),
            _createElementVNode("p", {
              dir: isRTL.value ? 'rtl' : 'ltr'
            }, _toDisplayString(_ctx.$t(blog.description)), 9, _hoisted_8)
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})